/**
 * Sidebar state while navigating from a notification, before entity data is loaded.
 */
export function openSidebarStateFromRedirectUrl(redirectUrl) {
  if (!redirectUrl) {
    return { show: false };
  }

  try {
    const url = new URL(redirectUrl, window.location.origin);
    const params = url.searchParams;
    const isComment = params.get('isComment') === 'true';
    const isAccounting = params.get('isAccounting') === 'true';
    const activeIndex = isComment ? 2 : isAccounting ? 1 : 0;

    const hasTransactionId =
      params.has('transactionId') ||
      (isComment && params.has('id') && url.pathname.includes('conciliacion'));
    const hasDocumentId = params.has('documentId');

    let type;
    if (hasTransactionId || url.pathname.includes('conciliacion')) {
      type = 'transactions';
    } else if (hasDocumentId || url.pathname.includes('documentos')) {
      type = 'documents';
    }

    return {
      show: false,
      reconcile: true,
      editData: null,
      ...(type ? { options: { type, activeIndex } } : {}),
    };
  } catch {
    return { show: false };
  }
}
